import Dialog from "../../atoms/dialog";
import DeleteEvent from "../events/DeleteEvent";

const DeleteEventAlert = ({ onCompletion, setShowDeleteEventAlert, eventId, onClose, isOpen, parentTransactionId, onDeleteConfirmation }) => {

    const handleClose = () => {
        onClose();
    }

    return (
        <Dialog
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteEventAlert" }}
        >
            <DeleteEvent onCompletion={onCompletion} onDeleteConfirmation={onDeleteConfirmation} setShowDeleteEventAlert={setShowDeleteEventAlert} eventId={eventId} onClose={handleClose} parentTransactionId={parentTransactionId} />
        </Dialog >
    )
}

export default DeleteEventAlert;